export enum FilterCategory {
  STATE = 'State',
  THERAPY_OR_PSYCHIATRY = 'Therapy or psychiatry',
  INSURANCE = 'Insurance',
  SPECIALTY = 'Concerns',
  GENDER_PREFERENCE = 'Gender preference',
  TREATMENT_APPROACH = 'Treatment approach',
  TYPE_OF_SERVICE = 'Type of service',
  SESSION_FORMAT = 'In-person or online',
  AGE_GROUP_TREATED = 'Age group treated',
  /** Admin directory only — rendered when FilterFormV2Component's `adminDirectory` is set. */
  LICENSURE = 'Licensure',
  /** Admin directory only, as above. */
  LANGUAGE = 'Languages spoken',
  /** Describes the provider, not the clients they serve; the two must not be conflated. */
  ETHNICITY = 'Provider race/ethnicity',
  LGBT_IDENTIFIED = 'Provider identifies as LGBTQIA+'
}
